// assets
import { HomeOutlined } from '@ant-design/icons';

// icons
const icons = {
    HomeOutlined,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const home = {
  id: 'group-home',
  title: '',
  type: 'group',
  children: [
    {
      id: 'home',
      title: 'Home',
      type: 'item',
      url: '/',
      icon: icons.HomeOutlined,
      breadcrumbs: true
    },
    // {
    //   id: 'home',
    //   title: 'Dashboard',
    //   type: 'item',
    //   url: '/dashboard',
    //   icon: icons.DashboardIcon,
    //   breadcrumbs: true
    // }
  ]
};

export default home;
